import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { projects } from '../data/mockData';

const ProjectsGrid = () => {
  const navigate = useNavigate();
  const [activeFilter, setActiveFilter] = useState('all');

  const filters = [
    { id: 'all', label: 'All' },
    { id: 'music', label: 'Music' },
    { id: 'books', label: 'Books' },
    { id: 'theatre', label: 'Theatre' }
  ];

  const filteredProjects = activeFilter === 'all'
    ? projects
    : projects.filter(project => project.category === activeFilter);

  return (
    <section className="py-32 px-4 bg-black" id="projects">
      <div className="container mx-auto max-w-7xl">
        {/* Section Title */}
        <div className="text-center mb-20">
          <h2 className="text-xs tracking-[0.3em] text-gold mb-4">OUR WORK</h2>
          <div className="w-16 h-px bg-gold mx-auto"></div>
        </div>

        {/* Filter Tabs */}
        <div className="flex justify-center gap-12 mb-20">
          {filters.map(filter => (
            <button
              key={filter.id}
              onClick={() => setActiveFilter(filter.id)}
              className={`text-sm tracking-[0.2em] pb-2 transition-all relative ${
                activeFilter === filter.id
                  ? 'text-white'
                  : 'text-white/40 hover:text-white/70'
              }`}
            >
              {filter.label.toUpperCase()}
              {activeFilter === filter.id && (
                <span className="absolute bottom-0 left-0 right-0 h-px bg-gold"></span>
              )}
            </button>
          ))}
        </div>

        {/* Projects Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
          {filteredProjects.map(project => (
            <div
              key={project.id}
              onClick={() => navigate(project.landingPage || `/project/${project.id}`)}
              className="group cursor-pointer"
            >
              <div className="relative overflow-hidden mb-6 aspect-[3/4] bg-zinc-900">
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover transition-all duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
                
                {/* Hover Indicator */}
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                  <span className="text-xs tracking-[0.3em] text-white border border-gold/50 px-6 py-2 backdrop-blur-sm">
                    VIEW
                  </span>
                </div>

                {/* Category Badge */}
                <div className="absolute top-4 left-4 text-[10px] tracking-[0.3em] text-gold">
                  {project.category.toUpperCase()}
                </div>

                {/* Status Badge */}
                {project.status === 'upcoming' && (
                  <div className="absolute top-4 right-4 text-[10px] tracking-[0.3em] text-white/60">
                    COMING SOON
                  </div>
                )}
              </div>

              <h3 className="text-2xl font-light text-white mb-3 group-hover:text-gold transition-colors leading-tight">
                {project.title}
              </h3>
              
              {project.artist && (
                <p className="text-sm text-white/50 mb-3 font-light">
                  {project.artist}
                </p>
              )}
              
              <p className="text-sm text-white/50 line-clamp-2 font-light leading-relaxed">
                {project.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProjectsGrid;
